module.exports = __webpack_public_path__ + "img/financial_revenue.9ac0dfb6.svg";